import styled from 'styled-components';
import type { SubscriptionStatus } from '../types';

const statusColors: Record<SubscriptionStatus, { background: string; color: string }> = {
    active: {
        background: 'var(--color-green-50, #f0fdf4)',
        color: 'var(--color-green-700, #15803d)',
    },
    trialing: {
        background: 'var(--color-blue-50, #eff6ff)',
        color: 'var(--color-blue-700, #1d4ed8)',
    },
    past_due: {
        background: 'var(--color-red-50, #fef2f2)',
        color: 'var(--color-red-700, #b91c1c)',
    },
    unpaid: {
        background: 'var(--color-red-50, #fef2f2)',
        color: 'var(--color-red-700, #b91c1c)',
    },
    canceled: {
        background: 'var(--color-gray-100, #f3f4f6)',
        color: 'var(--color-gray-600, #4b5563)',
    },
    incomplete: {
        background: 'var(--color-amber-50, #fffbeb)',
        color: 'var(--color-amber-700, #b45309)',
    },
    incomplete_expired: {
        background: 'var(--color-gray-100, #f3f4f6)',
        color: 'var(--color-gray-600, #4b5563)',
    },
    paused: {
        background: 'var(--color-amber-50, #fffbeb)',
        color: 'var(--color-amber-700, #b45309)',
    },
    none: {
        background: 'var(--color-gray-50, #f9fafb)',
        color: 'var(--color-gray-500, #6b7280)',
    },
};

export const StatusBadge = styled.span<{ $status: SubscriptionStatus }>`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    max-width: 100%;
    padding: 1px 7px;
    border-radius: 9999px;
    font-size: 11px;
    font-weight: 500;
    line-height: 1.4;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    background-color: ${({ $status }) => statusColors[$status].background};
    color: ${({ $status }) => statusColors[$status].color};
`;

export const StatusDot = styled.span<{ $status: SubscriptionStatus }>`
    width: 5px;
    height: 5px;
    border-radius: 50%;
    flex-shrink: 0;
    background-color: ${({ $status }) => statusColors[$status].color};
`;
